/* eslint-disable no-undefined */
import { createRef } from 'preact';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styleSheet from './styles/scorePredictor.module.scss';

import { useTranslation } from 'react-i18next';
import { ShareButton } from '@playbook/sdk-helpers';

import Hero from './hero.component';

const styles = styleSheet.locals || {};

/**
 * Component for the prediction header
 *
 * @param {object} props prediction option props
 * @param {object} props.scorePredictor scorePredictor option data
 * @param {boolean} props.isFormVisible adjust styles when form is showing
 * @param {object} props.interactionEvent analytics InteractionEvent instance
 * @returns {Function} <ScorePredictorHeader />
 */
function ScorePredictorHeader({
    scorePredictor,
    isFormVisible = false,
    interactionEvent
}) {
    const { t } = useTranslation();
    const isDraft =
        scorePredictor.state === 'draft' ||
        scorePredictor.state === 'scheduled';
    const hasHeroImg =
        scorePredictor.hero_image_url || scorePredictor.hero_external_image_url;

    const isOpen = scorePredictor.state === 'open';

    const titleRef = createRef();

    return (
        <div
            part="score-predictor-header"
            className={classNames(styles.scorePredictorHeader, {
                [styles.scorePredictorHeaderDraft]: isDraft,
                [styles.scorePredictorHeaderOpen]: isOpen
            })}
        >
            {hasHeroImg && (
                <Hero
                    scorePredictor={scorePredictor}
                    data-testid="predictor-hero"
                />
            )}

            <div
                data-cy="titleLabel"
                part="score-predictor-title"
                className={classNames(styles.scorePredictorTitle, {
                    [styles.scorePredictorTitleDraft]: isDraft,
                    [styles.scorePredictorTitleOpen]: !isDraft,
                    [styles.scorePredictorTitleForm]: isFormVisible
                })}
                ref={titleRef}
                data-fek-preview="text"
            >
                {scorePredictor.text}
                {!isDraft && (
                    <ShareButton
                        pageId={scorePredictor.prediction_id}
                        copiedLabel={t('button.shareCopied')}
                        ariaLabel={t('button.shareLabel')}
                        partPrefix="score-predictor-share"
                        onCopied={() =>
                            interactionEvent?.send('PREDICTION_SHARED')
                        }
                    />
                )}
            </div>
        </div>
    );
}

ScorePredictorHeader.propTypes = {
    scorePredictor: PropTypes.object.isRequired,
    isFormVisible: PropTypes.bool,
    interactionEvent: PropTypes.object
};

export default ScorePredictorHeader;
